import { Comune } from './comune';
import { Model } from './model';
import { Polizza } from './polizza';

export class SommaAssicurata extends Model {
    static apiUrl: string = "somme_assicurate";

    descrizione: string;
    valore: number;
    deroga_percentuale: number;
    polizza: Polizza;

    deserialize(input: any): SommaAssicurata {
        let retV: SommaAssicurata = new SommaAssicurata();

        retV = super.deserialize(input) as SommaAssicurata;


        if (input?.polizza) {
            retV.polizza = new Polizza().deserialize(input.polizza);
        }

        return retV;
    }

    public getHumanIdentifier() {
        return this.descrizione;
    }

    get valore_con_deroga() {
        return +this.valore + ((+this.valore / 100) * +this.deroga_percentuale)
    }

}
